import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * RouteBlocker Component
 *
 * Watches route changes and prevents navigation into restricted routes
 * when certain conditions are met.
 *
 * @component
 * @return {null}
 */
function FirstTimeLoginGuard() {
  const navigate = useNavigate();
  const location = useLocation();

  const { adminDetails } = useSelector((state) => state.adminDetails);

  /**
   * First-time login redirect logic
   */

      useEffect(() => {
        if (!adminDetails) return;

        if (adminDetails) {
            localStorage.setItem(
                'first_time_login',
                adminDetails?.first_time_login
                    ? adminDetails?.first_time_login
                    : ''
            );
            if (
                adminDetails?.first_time_login_enable &&
                adminDetails?.first_time_login
            ) {
                localStorage.setItem(
                    'first_time_login_enable',
                    adminDetails.first_time_login_enable
                );

                navigate("/profile", { replace: true });
            }
        }
  }, [adminDetails, navigate, location.pathname]);

  return null;
}

export default FirstTimeLoginGuard;
